/* eslint-disable eqeqeq */
import React, { useState, useCallback, useEffect } from "react";

/** Components */
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper, ButtonGroup, Button, Collapse, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import { useSnackbar } from "notistack";

/** Icons */
import SearchIcon from "@mui/icons-material/Search";

/** Api & Function */
import { getCurrency, getCustomers, getRPTDebt } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
import { fitToColumn } from "../../../services/libService";

/** Package */
import dayjs from "dayjs";

/** Hook */
import { useTranslation } from "react-i18next";
import { ExcelIcon } from "../../commons/miscellaneous";
import * as XLSX from "xlsx";
import { moneyFormat } from "../../config";
import { useDispatch } from "react-redux";

const initialFilter = {
  start_date: "",
  end_date: "",
  selectedCustomer: null,
  currency: null,
};

const RptDebt = () => {
  // custom hook
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();
  // state
  const [isAllow, setAllow] = useState(true);
  const [arrayData, setArrayData] = useState([]);
  const totalClosingDebit = arrayData?.reduce((a, b) => a + b.closing_debit, 0);
  const totalClosingCredit = arrayData?.reduce((a, b) => a + b.closing_credit, 0);
  const totalInperiodDebit = arrayData?.reduce((a, b) => a + b.inperiod_debit, 0);
  const totalInperiodCredit = arrayData?.reduce((a, b) => a + b.inperiod_credit, 0);
  const totalOpeningDebit = arrayData?.reduce((a, b) => a + b.opening_debit, 0);
  const totalOpeningCredit = arrayData?.reduce((a, b) => a + b.opening_credit, 0);
  const [open, setOpen] = useState(true);
  const [input, setInput] = useState({ ...initialFilter, end_date: dayjs().format("YYYY-MM-DD") });
  // methods
  const handleSearch = useCallback(
    async (source) => {
      setArrayData();
      const params = {};
      if (input.selectedCustomer) params.customer_id = input.selectedCustomer.id;
      if (input.start_date) params.start_date = input.start_date;
      if (input.end_date) params.end_date = input.end_date;
      if (input.currency) params.currency_id = input.currency.id;
      return getRPTDebt(params).then((res) => {
        if (res.code === 403) {
          setAllow(false);
          setArrayData([]);
          return;
        }
        if (res.code !== 200) {
          enqueueSnackbar(res.message);
          setArrayData([]);
          return;
        }
        setArrayData(res.data);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [input]
  );
  const exportExcel = () => {
    const arrData = arrayData.map((item, index) => ({
      // làm thế này để xác định những cột nào định dạng string trong file csv
      "Mã khách hàng": item.customer_id,
      "Tên khách hàng": item.customer_name,
      "Tiền tệ": item.currency,
      "Số dư đầu kỳ (Nợ)": +item.opening_debit,
      "Số dư đầu kỳ (Có)": +item.opening_credit,
      "Phát sinh trong kỳ (Nợ)": +item.inperiod_debit,
      "Phát sinh trong kỳ (Có)": +item.inperiod_credit,
      "Số dư cuối kỳ (Nợ)": +item.closing_debit,
      "Số dư cuối kỳ (Có)": +item.closing_credit,
    }));
    const worksheet = XLSX.utils.json_to_sheet(arrData);
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [["Tổng", "", input.currency?.id == 14 ? "USD" : "VND", +totalOpeningDebit, +totalOpeningCredit, totalInperiodDebit, totalInperiodCredit, totalClosingDebit, totalClosingCredit]],
      { origin: -1 }
    );
    worksheet["!cols"] = fitToColumn(arrData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet);
    XLSX.writeFileXLSX(workbook, `BCN ${input.selectedCustomer?.name || ""}.xlsx`);
  };

  useEffect(() => {
    dispatch(setHeaderTitle("BÁO CÁO THEO DÕI CÔNG NỢ CỦA KHÁCH HÀNG"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          <Button onClick={exportExcel} style={{ display: Boolean(arrayData?.length) ? "" : "none" }}>
            <Tooltip title="Xuất dữ liệu ra file Excel">
              <ExcelIcon />
            </Tooltip>
          </Button>
          <Button onClick={() => setOpen((prev) => !prev)} variant="outlined">
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
        </ButtonGroup>
      </div>
      {/* filter */}
      <Collapse in={open}>
        <FilterBy
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getCustomers({ status: 1 })}
          value={input.selectedCustomer || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, selectedCustomer: newValue }))}
          label={t("Khách hàng")}
        />
        <CustomDatePicker label={t("Ngày bắt đầu")} value={input.start_date} onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))} sx={{ margin: "5px" }} />
        <CustomDatePicker label={t("Ngày kết thúc")} value={input.end_date} onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))} sx={{ margin: "5px" }} />
        <FilterBy
          style={{ display: "inline-flex", margin: "5px", minWidth: 240 }}
          getDataFunc={() => getCurrency({ status: 1 })}
          value={input.currency || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, currency: newValue }))}
          label={t("Tiền tệ")}
          getOptionLabel={(option) => option.code}
        />
        <ButtonWithAPICall api={handleSearch} disableSnackbar={() => true} variant="outlined">
          {t("Tìm kiếm")}
        </ButtonWithAPICall>
      </Collapse>
      <div>
        {!arrayData ? (
          <LoadingProgress />
        ) : (
          <TableContainer component={Paper} suppressHydrationWarning>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell rowSpan={2} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    STT
                  </TableCell>
                  <TableCell rowSpan={2} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    Mã khách hàng
                  </TableCell>
                  <TableCell rowSpan={2} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    Tên khách hàng
                  </TableCell>
                  <TableCell rowSpan={2} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    Tiền tệ
                  </TableCell>
                  <TableCell rowSpan={1} style={{ border: "1px solid lightgray" }} colSpan={2}>
                    Số dư đầu kỳ
                  </TableCell>
                  <TableCell rowSpan={1} style={{ border: "1px solid lightgray" }} colSpan={2}>
                    Phát sinh trong kỳ
                  </TableCell>
                  <TableCell rowSpan={1} style={{ border: "1px solid lightgray" }} colSpan={2}>
                    Số dư cuối kỳ
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ border: "1px solid lightgray" }}>Nợ</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>Có</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>Nợ</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>Có</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>Nợ</TableCell>
                  <TableCell style={{ border: "1px solid lightgray" }}>Có</TableCell>
                </TableRow>
              </TableHead>
              <TableBody suppressHydrationWarning>
                {arrayData?.length ? (
                  arrayData.map((row, index) => (
                    <TableRow hover component={Link} to={`/debt?customer_id=${row.customer_id}&start_date=${input.start_date}&end_date=${input.end_date}`} key={index}>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }}>
                        {row.customer_id}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="left">
                        {row.customer_name}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }}>
                        {row.currency}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="right">
                        {moneyFormat(row.opening_debit, row.currency)}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="right">
                        {moneyFormat(row.opening_credit, row.currency)}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="right">
                        {moneyFormat(row.inperiod_debit, row.currency)}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="right">
                        {moneyFormat(row.inperiod_credit, row.currency)}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="right">
                        {moneyFormat(row.closing_debit, row.currency)}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="right">
                        {moneyFormat(row.closing_credit, row.currency)}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={20}>
                      {t(isAllow ? "Không có dữ liệu" : "No permission")}
                    </TableCell>
                  </TableRow>
                )}
                <TableRow style={{ display: arrayData.length ? "" : "none" }}>
                  <TableCell style={{ border: "1px solid lightgray", fontWeight: "bold" }} colSpan={3} align="center">
                    Tổng
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", fontWeight: "bold" }} colSpan={1} align="center">
                    {input.currency?.id == 14 ? "USD" : "VND"}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", fontWeight: "bold" }} colSpan={1} align="right">
                    {moneyFormat(totalOpeningDebit, input.currency?.id == 14 ? "USD" : "VND")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", fontWeight: "bold" }} colSpan={1} align="right">
                    {moneyFormat(totalOpeningCredit, input.currency?.id == 14 ? "USD" : "VND")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", fontWeight: "bold" }} colSpan={1} align="right">
                    {moneyFormat(totalInperiodDebit, input.currency?.id == 14 ? "USD" : "VND")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", fontWeight: "bold" }} colSpan={1} align="right">
                    {moneyFormat(totalInperiodCredit, input.currency?.id == 14 ? "USD" : "VND")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", fontWeight: "bold" }} colSpan={1} align="right">
                    {moneyFormat(totalClosingDebit, input.currency?.id == 14 ? "USD" : "VND")}
                  </TableCell>
                  <TableCell style={{ border: "1px solid lightgray", fontWeight: "bold" }} colSpan={1} align="right">
                    {moneyFormat(totalClosingCredit, input.currency?.id == 14 ? "USD" : "VND")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default RptDebt;
